import { Stack, Typography } from "@mui/material";

import { BasicCardStack, StyledItemRow } from "./styles";
import ItemFields from "./ItemFields";

export const QuoteCalcTable = () => {
  return (
    <BasicCardStack sx={{ padding: 0, gap: 0 }} justifyContent="space-between">
      <Stack>
        <StyledItemRow header includePadding>
          <Typography variant="caption">Description</Typography>
          <Typography variant="caption" sx={{ ml: "auto", mr: "8px" }}>
            Value
          </Typography>
        </StyledItemRow>
        <ItemFields />
      </Stack>
    </BasicCardStack>
  );
};

export default QuoteCalcTable;
